(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zr-storefront"] && !Shopify.designMode) return;
  try {
    (() => {
  if (Number(window.Shopify?.theme?.id) !== 155870167189 || location.pathname.includes('custom-design-studio') || new URLSearchParams(location.search).get('view') === 'custom-design-studio') return;
  const scope = '[data-zr-card], [data-zr-product], .zr-quick';
  const initialized = new WeakSet();
  const labels = () => document.querySelector('[data-zr-labels]')?.dataset || {};
  function indicator(scroller, slides, host) {
    if (initialized.has(scroller)) return;
    initialized.add(scroller);
    const dots = document.createElement('div'); dots.className = 'zr-dots'; dots.setAttribute('role','img'); host.append(dots);
    const update = () => {
      const items = [...scroller.querySelectorAll(slides)].filter(e => !e.hidden && getComputedStyle(e).display !== 'none');
      dots.hidden = items.length < 2;
      dots.style.display = items.length < 2 ? 'none' : '';
      if (dots.children.length !== items.length) dots.replaceChildren(...items.map(() => document.createElement('span')));
      const left = scroller.getBoundingClientRect().left;
      let index = 0, distance = Infinity;
      items.forEach((e,i) => { const d = Math.abs(e.getBoundingClientRect().left-left); if(d < distance){distance=d;index=i;} });
      [...dots.children].forEach((e,i) => e.setAttribute('aria-current',String(i===index)));
      dots.setAttribute('aria-label',`${index+1} / ${items.length}`);
    };
    scroller.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(scroller);
    new MutationObserver(update).observe(scroller,{subtree:true,attributes:true,attributeFilter:['hidden','aria-hidden']});
    update();
  }
  function setup() {
    document.querySelectorAll(`${scope}`).forEach(root => {
      if(root.matches('[data-zr-card]')&&!initialized.has(root)){
        initialized.add(root);
        let start=null,suppress=false;
        root.addEventListener('mousedown',event=>{
          if(!matchMedia('(max-width:749px)').matches||!event.target.closest('slideshow-slides')||event.target.closest('button'))return;
          start={x:event.clientX,y:event.clientY};suppress=false;event.preventDefault();event.stopImmediatePropagation();
        },true);
        root.addEventListener('mouseup',event=>{
          if(!start)return;
          const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
          if(Math.abs(dx)<35||Math.abs(dx)<Math.abs(dy))return;
          event.preventDefault();event.stopImmediatePropagation();suppress=true;
          const handler=root.getAttribute('on:click');root.removeAttribute('on:click');
          const slider=root.querySelector('slideshow-component');
          if(dx<0)slider?.next(event);else slider?.previous(event);
          setTimeout(()=>{suppress=false;if(handler)root.setAttribute('on:click',handler);},500);
        },true);
        root.addEventListener('click',event=>{if(suppress){event.preventDefault();event.stopImmediatePropagation();}},true);
      }
      root.querySelectorAll('slideshow-container').forEach(host => {
        const s=host.querySelector('slideshow-slides'); if(s) indicator(s,'slideshow-slide',host);
      });
      root.querySelectorAll('.Vtl-WishlistButton__WishlistIconButton,.Vtl-WishlistButton__AddToWishlist').forEach(button => {
        if(initialized.has(button)) return; initialized.add(button);
        button.tabIndex=0; button.setAttribute('role','button'); button.setAttribute('aria-label',button.title || labels().favorite || 'Favorite');
        button.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();button.click();}});
      });
    });
    document.querySelectorAll('[data-zr-product]:not(quick-add-dialog *)').forEach(root=>{
      const favorite=root.querySelector('.Vtl-WishlistButtonWrapper'), actions=root.querySelector('.zr-actions');
      if(favorite && actions && favorite.parentElement!==actions)actions.prepend(favorite);
    });
    const quick = document.querySelector('#quick-add-dialog dialog');
    if(quick?.querySelector('[data-zr-product],.zr-options')) quick.classList.add('zr-quick');
    document.querySelectorAll('[data-zr-product] .zr-options').forEach(wrapper => {
      if(wrapper.closest('quick-add-dialog')) return;
      if(initialized.has(wrapper)) return; initialized.add(wrapper);
      const dialog=wrapper.querySelector('dialog'), open=wrapper.querySelector('[data-zr-open]'), close=wrapper.querySelector('[data-zr-close]');
      if(!dialog || !open || !close) return;
      dialog.close();open.hidden=false;close.hidden=false;
      open.setAttribute('aria-expanded','false');
      open.addEventListener('click',()=>{
        if(matchMedia('(max-width:749px)').matches)dialog.showModal();else dialog.show();
        open.setAttribute('aria-expanded','true');
        if(!matchMedia('(max-width:749px)').matches)dialog.scrollIntoView({block:'nearest',behavior:'instant'});
      });
      dialog.addEventListener('close',()=>{if(!dialog.open){open.setAttribute('aria-expanded','false');open.focus({preventScroll:true});}});
      const responsiveMode=matchMedia('(max-width:749px)');
      responsiveMode.addEventListener('change',()=>{if(dialog.open){dialog.close();if(responsiveMode.matches)dialog.showModal();else dialog.show();}});
      dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();dialog.close();}});
      close.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
      document.addEventListener('cart:update',()=>{if(dialog.open)dialog.close();});
    });
    document.querySelectorAll('[data-zr-product]:not(quick-add-dialog *)').forEach(root => {
      if(initialized.has(root))return;initialized.add(root);
      const media=root.querySelector('.product-information__media');if(!media)return;
      const actions=document.createElement('div');actions.className='zr-actions';
      const share=document.createElement('button');share.type='button';share.className='zr-glass';share.textContent=labels().share || 'Share product';
      const panel=document.createElement('div');panel.className='zr-share-panel';panel.hidden=true;
      const input=document.createElement('input');input.readOnly=true;input.setAttribute('aria-label',labels().copy||'Product link');
      const copy=document.createElement('button');copy.type='button';copy.className='zr-glass';copy.textContent=labels().copy||'Copy link';
      const status=document.createElement('span');status.setAttribute('role','status');status.setAttribute('aria-live','polite');
      panel.append(input,copy,status);
      const publicUrl=()=>{const url=new URL(root.dataset.zrShareUrl||document.querySelector('link[rel="canonical"]').href);url.search='';url.hash='';return url.href;};
      copy.addEventListener('click',async()=>{
        input.select();
        try{await navigator.clipboard.writeText(input.value);status.textContent=labels().copied||'Link copied';}
        catch{status.textContent=document.execCommand('copy')?(labels().copied||'Link copied'):'Select and copy the product link above.';}
      });
      share.addEventListener('click',async()=>{
        const data={title:root.querySelector('h1')?.textContent.trim()||document.title,url:publicUrl()};
        input.value=data.url;panel.hidden=false;status.textContent='Use your device share menu, or copy the product link below.';
        if(navigator.share&&(!navigator.canShare||navigator.canShare(data))){
          try{await navigator.share(data);status.textContent='Product link ready to share.';return;}catch(error){if(error.name==='AbortError')return;}
        }
        panel.hidden=false;status.textContent='Copy this product link to share.';input.focus();input.select();
      });
      actions.append(panel);

      actions.append(share);media.prepend(actions);
    });
    document.querySelectorAll('[data-zr-product] zoom-dialog').forEach(zoom=>{
        const dialog=zoom.querySelector('dialog'),list=zoom.querySelector('.dialog-zoomed-gallery');
        if(!dialog||!list||initialized.has(zoom))return;initialized.add(zoom);indicator(list,':scope > li',dialog);
        const mode=matchMedia('(max-width:749px)');
        const syncZoom=()=>[...list.children].forEach(e=>mode.matches?e.removeAttribute('on:click'):e.setAttribute('on:click','/close'));
        syncZoom();mode.addEventListener('change',syncZoom);
        const advance = delta => {
          const next=Math.max(0,Math.min(list.children.length-1,Math.round(list.scrollLeft/list.clientWidth)+delta));
          list.dataset.zrImage=String(next+1);list.scrollTo({left:next*list.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
          zoom.querySelectorAll('.dialog-thumbnails-list button').forEach((b,i)=>b.setAttribute('aria-selected',String(i===next)));
        };
        let mouseStart=null,swiped=false;
        list.addEventListener('mousedown',e=>{if(matchMedia('(max-width:749px)').matches){mouseStart={x:e.clientX,y:e.clientY};swiped=false;e.preventDefault();}},true);
        list.addEventListener('mouseup',e=>{if(!mouseStart)return;const dx=e.clientX-mouseStart.x,dy=e.clientY-mouseStart.y;mouseStart=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){e.preventDefault();e.stopPropagation();swiped=true;advance(dx<0?1:-1);}},true);
        let touchStart=null;
        list.addEventListener('touchstart',e=>{if(!matchMedia('(max-width:749px)').matches||e.touches.length!==1)return;touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};swiped=false;e.stopPropagation();},{capture:true,passive:true});
        list.addEventListener('touchmove',e=>{if(!touchStart||e.touches.length!==1)return;if(Math.abs(e.touches[0].clientX-touchStart.x)>Math.abs(e.touches[0].clientY-touchStart.y)){e.preventDefault();e.stopPropagation();}},{capture:true,passive:false});
        list.addEventListener('touchend',e=>{if(!touchStart)return;const t=e.changedTouches[0],dx=t.clientX-touchStart.x,dy=t.clientY-touchStart.y;touchStart=null;e.stopPropagation();if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){e.preventDefault();swiped=true;advance(dx<0?1:-1);}},{capture:true,passive:false});
        list.addEventListener('click',e=>{if(swiped){e.preventDefault();e.stopImmediatePropagation();swiped=false;}},true);
        const arrows=document.createElement('div');arrows.className='zr-zoom-arrows';
        [-1,1].forEach(delta=>{const button=document.createElement('button');button.type='button';button.className='zr-glass';button.textContent=delta<0?'←':'→';button.setAttribute('aria-label',delta<0?'Previous image':'Next image');button.addEventListener('click',()=>{const buttons=[...zoom.querySelectorAll('.dialog-thumbnails-list button')];let i=buttons.findIndex(b=>b.getAttribute('aria-selected')==='true');buttons[(i+delta+buttons.length)%buttons.length]?.click();});arrows.append(button);});dialog.append(arrows);
    });
  }
  document.addEventListener('click',e=>{
    const trigger=e.target.closest?.('quick-add-component button');
    if(trigger)document.querySelector('#quick-add-dialog dialog')?.classList.toggle('zr-quick',!!trigger.closest('[data-zr-card]'));
  },true);
  document.addEventListener('variant:update',event=>{
    const root=event.target.closest?.('[data-zr-product],.zr-quick');
    const html=event.detail?.data?.html;
    if(!root||!html)return;
    const preview=root.querySelector('.zr-config-image'),variant=event.detail.resource;
    const image=variant?.featured_media?.preview_image||variant?.featured_image;
    if(preview&&image?.src){preview.removeAttribute('srcset');preview.src=image.src;preview.alt=variant.name||variant.title||preview.alt;}

    root.querySelectorAll('product-price').forEach(price=>{
      if(price.dataset.productId!==event.target.dataset.productId)return;
      const fresh=[...html.querySelectorAll('product-price')].find(p=>p.dataset.blockId===price.dataset.blockId);
      const source=fresh?.querySelector('[ref="priceContainer"]'),target=price.querySelector('[ref="priceContainer"]');
      if(source&&target)target.replaceChildren(...[...source.childNodes].map(n=>n.cloneNode(true)));
    });
  });
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;setup();});};
  const start=()=>{setup();for(const root of [document.querySelector('#MainContent'),document.querySelector('#quick-add-modal-content')])if(root)new MutationObserver(schedule).observe(root,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

})();
